import Joi from "joi";
import { DriverShiftAssignment } from "../../../graphql/generated";

const driverShiftAssignmentSchema = Joi.object<DriverShiftAssignment>({
  _id: Joi.string().allow(null).label("ID"),
  driverId: Joi.string().required().label("Driver"),
  driverShiftId: Joi.string().required().label("Driver Shift"),
  startDate: Joi.date().allow(null).label("Start Date and Time"),
  endDate: Joi.date().allow(null).label("End Date and Time"),
}).custom((value, helpers) => {
  const { driverShiftId, startDate, endDate } = value;

  // When creating a custom shift (NEW), both dates are required
  if (driverShiftId === "NEW") {
    if (!startDate) {
      return helpers.message({
        custom: "Start Date and Time is required for custom shifts",
      });
    }
    if (!endDate) {
      return helpers.message({
        custom: "End Date and Time is required for custom shifts",
      });
    }
  }

  if (startDate && endDate && startDate > endDate) {
    return helpers.message({
      custom: "Start date must be before end date",
    });
  }
  return value;
});

export default driverShiftAssignmentSchema;
